import React, { useEffect, useState } from 'react';
import { X, CheckCircle } from 'lucide-react';
export function LivePopup() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Show popup after 5 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Hide after 10 seconds of being visible
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 15000);
    return () => {
      clearTimeout(timer);
      clearTimeout(hideTimer);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-slide-up" data-id="element-99">
      <div className="bg-white text-black rounded-lg shadow-2xl border border-gray-200 p-4 pr-10 relative max-w-sm flex items-start gap-3" data-id="element-100">
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-black" data-id="element-101">
          <X className="w-4 h-4" data-id="element-102" />
        </button>

        <div className="bg-brand/10 p-2 rounded-full shrink-0" data-id="element-103">
          <CheckCircle className="w-5 h-5 text-brand" data-id="element-104" />
        </div>

        <div data-id="element-105">
          <div className="text-xs font-bold text-brand uppercase tracking-wider mb-1" data-id="element-106">
            Compra verificada
          </div>
          <div className="text-sm font-medium" data-id="element-107">
            <strong data-id="element-108">Florencia B.</strong> de La Plata
          </div>
          <div className="text-sm text-gray-600" data-id="element-109">
            compró Pack + Acelerador 🏆 hace 9 minutos
          </div>
        </div>
      </div>
    </div>;
}